import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "grid grid-cols-1 gap-4 md:grid-cols-12" }
const _hoisted_3 = { class: "md:col-span-12" }
const _hoisted_4 = { class: "rounded-lg border border-slate-200 bg-white p-4" }
const _hoisted_5 = { class: "grid grid-cols-1 gap-4 md:grid-cols-12" }
const _hoisted_6 = { class: "flex min-w-0 flex-col md:col-span-4" }
const _hoisted_7 = { class: "flex min-w-0 flex-col md:col-span-4" }
const _hoisted_8 = { class: "flex min-w-0 flex-col justify-end md:col-span-3" }
const _hoisted_9 = { class: "flex flex-wrap items-end gap-2 md:col-span-12" }
const _hoisted_10 = { class: "md:col-span-12" }
const _hoisted_11 = { class: "flex flex-wrap items-center justify-between gap-3" }
const _hoisted_12 = { class: "text-sm font-medium text-slate-500" }
const _hoisted_13 = { class: "relative flex w-full max-w-[420px]" }
const _hoisted_14 = { class: "max-w-[680px] whitespace-pre-wrap leading-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Panel, { header: "Danh sách khẩn cấp" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("section", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[6] || (_cache[6] = _createElementVNode("label", null, "Từ thời gian", -1)),
                  _createVNode(_component_InputText, {
                    modelValue: $setup.timeFrom,
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = ($event: any) => (($setup.timeFrom) = $event)),
                      _cache[1] || (_cache[1] = ($event: any) => ($setup.selectedQuickRange = ''))
                    ],
                    type: "datetime-local"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[7] || (_cache[7] = _createElementVNode("label", null, "Đến thời gian", -1)),
                  _createVNode(_component_InputText, {
                    modelValue: $setup.timeTo,
                    "onUpdate:modelValue": [
                      _cache[2] || (_cache[2] = ($event: any) => (($setup.timeTo) = $event)),
                      _cache[3] || (_cache[3] = ($event: any) => ($setup.selectedQuickRange = ''))
                    ],
                    type: "datetime-local"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_Button, {
                    label: "Làm mới danh sách",
                    icon: "pi pi-refresh",
                    iconPos: "left",
                    loading: $setup.isLoading,
                    disabled: !$setup.timeFrom || !$setup.timeTo,
                    onClick: $setup.loadEmergencies
                  }, null, 8, ["loading", "disabled", "onClick"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_Button, {
                    label: "Hôm nay",
                    outlined: $setup.selectedQuickRange !== 'today',
                    onClick: $setup.selectToday
                  }, null, 8, ["outlined", "onClick"]),
                  _createVNode(_component_Button, {
                    label: "7 ngày gần nhất",
                    outlined: $setup.selectedQuickRange !== 'last7Days',
                    onClick: $setup.selectLast7Days
                  }, null, 8, ["outlined", "onClick"]),
                  _createVNode(_component_Button, {
                    label: "Tháng này",
                    outlined: $setup.selectedQuickRange !== 'thisMonth',
                    onClick: $setup.selectThisMonth
                  }, null, 8, ["outlined", "onClick"])
                ])
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_10, [
            _createVNode(_component_DataTable, {
              filters: $setup.filters,
              "onUpdate:filters": _cache[5] || (_cache[5] = ($event: any) => (($setup.filters) = $event)),
              loading: $setup.isLoading,
              value: $setup.emergencies,
              paginator: true,
              rows: 10,
              sortField: "time",
              sortOrder: -1
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", null, [
                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-[15px] font-black text-slate-900" }, " Nội dung khẩn cấp ", -1)),
                    _createElementVNode("div", _hoisted_12, " Tổng số: " + _toDisplayString($setup.emergencies.length) + " báo cáo ", 1)
                  ]),
                  _createElementVNode("span", _hoisted_13, [
                    _cache[9] || (_cache[9] = _createElementVNode("i", { class: "pi pi-search pointer-events-none absolute left-3 top-1/2 z-10 -translate-y-1/2 text-sm text-slate-400" }, null, -1)),
                    _createVNode(_component_InputText, {
                      modelValue: $setup.filters['global'].value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.filters['global'].value) = $event)),
                      class: "!pl-8 !pr-3",
                      placeholder: "Tìm theo tên, số điện thoại hoặc nội dung"
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "fullName",
                  header: "Họ và tên",
                  sortable: ""
                }, {
                  body: _withCtx(({ data }) => [
                    _createTextVNode(_toDisplayString(data.fullName || "-"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "phoneNumber",
                  header: "Số điện thoại",
                  sortable: ""
                }, {
                  body: _withCtx(({ data }) => [
                    _createTextVNode(_toDisplayString(data.phoneNumber || "-"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "content",
                  header: "Nội dung"
                }, {
                  body: _withCtx(({ data }) => [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(data.content || "-"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "time",
                  header: "Thời gian gửi",
                  sortable: ""
                }, {
                  body: _withCtx(({ data }) => [
                    _createTextVNode(_toDisplayString($setup.formatDateTime(data.time)), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["filters", "loading", "value"])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}